import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=02d648bc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02d648bc')) {
      api.createRecord('02d648bc', component.options)
    } else {
      api.reload('02d648bc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=02d648bc&", function () {
      api.rerender('02d648bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BXS9vb2G7h7a/JS/comp/FavElement.vue"
export default component.exports